module.exports = __webpack_public_path__ + "img/JT.c48013bf.png";